import { ArrowUp, ArrowDown, Minus } from "lucide-react";

export function RankChange({ change, testid }) {
  if (change == null)
    return <span data-testid={testid} className="text-slate-500 text-[11px] font-mono">NEW</span>;
  if (change > 0)
    return (
      <span data-testid={testid} className="text-emerald-400 text-[11px] font-mono font-bold inline-flex items-center gap-0.5">
        <ArrowUp className="w-3 h-3" />{change}
      </span>
    );
  if (change < 0)
    return (
      <span data-testid={testid} className="text-rose-400 text-[11px] font-mono font-bold inline-flex items-center gap-0.5">
        <ArrowDown className="w-3 h-3" />{Math.abs(change)}
      </span>
    );
  return (
    <span data-testid={testid} className="text-slate-500 text-[11px] font-mono inline-flex items-center">
      <Minus className="w-3 h-3" />
    </span>
  );
}

export function ProvisionalTag({ matches, threshold }) {
  return (
    <span
      data-testid="provisional-tag"
      className="inline-flex items-center px-2 py-0.5 rounded-full text-[10px] font-mono font-bold uppercase tracking-wider bg-amber-950/60 text-amber-300 border border-amber-500/40"
    >
      Provisional{matches != null && threshold ? ` · ${matches}/${threshold}` : ""}
    </span>
  );
}

// Phase 16 Delta 1 — OFFICIAL requires BOTH gates: results ≥ 25 AND RD ≤ 100
export function OfficialProgress({ progress, status, testid = "official-progress" }) {
  if (!progress) return null;
  const rPct = Math.min(100, (progress.results / progress.results_required) * 100);
  const isOfficial = status === "OFFICIAL";
  const Bar = ({ label, pct, met, value }) => (
    <div className="mt-1.5">
      <div className="flex items-center justify-between text-[9px] font-mono uppercase tracking-wider mb-0.5">
        <span className="text-slate-500">{label}</span>
        <span className={met ? "text-emerald-400" : "text-amber-300"}>{value}</span>
      </div>
      <div className="h-1 rounded-full bg-[#2b2512] overflow-hidden">
        <div className={`h-full rounded-full transition-all ${met ? "bg-emerald-400" : "bg-amber-400"}`}
             style={{ width: `${pct}%` }} />
      </div>
    </div>
  );
  return (
    <div data-testid={testid} className="mt-2">
      <div className={`text-[10px] font-mono font-bold uppercase tracking-wider ${isOfficial ? "text-emerald-400" : "text-amber-300"}`}>
        {isOfficial ? "Official Ranked" : "Provisional"}
      </div>
      <Bar label="Results" pct={rPct} met={progress.results_met}
           value={`${progress.results}/${progress.results_required}`} />
      <Bar label="RD ≤ 100" pct={progress.rd != null ? Math.min(100, (100 / Math.max(progress.rd, 1)) * 100) : 0}
           met={progress.rd_met} value={progress.rd != null ? progress.rd.toFixed(0) : "—"} />
    </div>
  );
}

// Phase 16 Delta 5 — inactivity active-ranking adjustment layer
export function InactivityBadge({ active, testid = "inactivity-badge" }) {
  if (!active || !active.is_inactive) return null;
  return (
    <span data-testid={testid}
      className="inline-flex items-center px-2 py-0.5 rounded-full text-[10px] font-mono font-bold uppercase tracking-wider bg-rose-950/60 text-rose-300 border border-rose-500/40">
      {active.label}
    </span>
  );
}

export function RatingValue({ value, className = "" }) {
  return (
    <span className={`font-heading font-black tabular-nums text-[#E5B842] ${className}`}>
      {value != null ? Math.round(value) : "—"}
    </span>
  );
}
